// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Rollbar from "rescript-rollbar/src/Rollbar.bs.mjs";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as CSS$MakerDs from "maker-ds/src/CSS.bs.mjs";
import * as ClerkReact from "@clerk/clerk-react";

function ErrorPage(Props) {
  var err = Props.err;
  var cause = Rollbar.$$Error.fromRescript(err);
  var rootCause = Rollbar.$$Error.getRootCause(cause);
  var rootCauseMessage = Belt_Option.getWithDefault(rootCause.message, "Unknown");
  var userId = window.ENV.userId;
  return React.createElement("div", {
              className: CSS$MakerDs.prefix("h-screen w-screen bg-red-500 text-white flex flex-col")
            }, React.createElement("div", {
                  className: CSS$MakerDs.prefix("w-full p-4 flex justify-between bg-red-600 text-lg font-semibold")
                }, React.createElement("a", {
                      className: CSS$MakerDs.prefix("text-white hover:underline"),
                      href: "/"
                    }, "Back"), React.createElement("div", {
                      className: CSS$MakerDs.prefix("flex justify-end items-center gap-2 pb-8")
                    }, React.createElement("span", {
                          className: CSS$MakerDs.prefix("text-sm text-gray-600 font-medium flex")
                        }, (userId == null) ? React.createElement(React.Fragment, undefined, React.createElement(ClerkReact.OrganizationSwitcher, {
                                    hidePersonal: true
                                  }), React.createElement(ClerkReact.UserButton, {})) : "Account ID #" + userId + ""))), React.createElement("div", {
                  className: CSS$MakerDs.prefix("flex flex-grow justify-center items-center text-2xl font-bold text-center")
                }, React.createElement("div", {
                      className: CSS$MakerDs.prefix("")
                    }, rootCauseMessage)));
}

var make = ErrorPage;

export {
  make ,
}
/* react Not a pure module */
